/**
 * A collection of useful helpers with no external dependencies
 */


var Helpers = {

  generateBrowserFingerprint() {
    return 'aa';
  },
  getMSIEVersion: function () {
    var version = -1

    if (navigator) {
      var userAgent = navigator.userAgent
      var regEx = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})')
      if (regEx.exec(userAgent) != null) {
        version = parseFloat(RegExp.$1)
      }
    }
    return version
  },
  getTridentVersion: function () {
    var version = -1

    if (navigator) {
      var userAgent = navigator.userAgent
      var regEx = new RegExp('Trident/([0-9]{1,}[\.0-9]{0,})')

      if (regEx.exec(userAgent) != null) {
        version = parseFloat(RegExp.$1)
      }
    }

    return version
  },
  wrapElement: function (children, wrapper) {
    // Convert `elms` to an array, if necessary.
    if (!children.length) children = [children]

    // Loops backwards to prevent having to clone the wrapper on the
    // first element (see `child` below).
    for (var i = children.length - 1; i >= 0; i--) {
      var child = (i > 0) ? wrapper.cloneNode(true) : this
      var el = children[i]

      // Cache the current parent and sibling.
      var parent = el.parentNode
      var sibling = el.nextSibling

      // Wrap the element (is automatically removed from its current
      // parent).
      child.appendChild(el)

      // If the element had a sibling, insert the wrapper before
      // the sibling to maintain the HTML structure; otherwise, just
      // append it to the parent.
      if (sibling) {
        parent.insertBefore(child, sibling)
      } else {
        parent.appendChild(child)
      }
    }
  },

  getURLParameter: function (name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [null, ''])[1].replace(/\+/g, '%20')) || null
  },

  /**
   * [throttle description]
   * @param  {Function} callback [description]
   * @param  {int}   limit    ms
   */
  throttle: function (callback, limit) {
    var wait, queuedCall = false // Initially, we're not waiting
    return function () {
      // We return a throttled function
      if (!wait) { // If we're not waiting
        callback.call() // Execute users function
        wait = true // Prevent future invocations
        setTimeout(function () { // After a period of time
          if (queuedCall) {
            queuedCall = false
            callback.call()
          }
          wait = false // And allow future invocations
        }, limit)
      } else {
        queuedCall = true
      }
    }
  },

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  debounce: function (func, wait, immediate) {
    var timeout
    return function () {
      var context = this, args = arguments
      var later = function () {
        timeout = null
        if (!immediate) func.apply(context, args)
      }
      var callNow = immediate && !timeout
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
      if (callNow) func.apply(context, args)
    }
  },
  getElementTopOffset: function (element) {
    if (!element) return false

    return element.getBoundingClientRect().top + this.getScrollTop()
  },
  getScrollTop: function () {
    // takes care of cross browser differences
    return document.documentElement.scrollTop || document.body.scrollTop
  },

  getViewportDimension: function () {
    return {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight
    }
  },

  // // Returns the height of the viewport
  getViewportHeight: function () {
    return document.documentElement.clientHeight
  },

  getViewportWidth: function () {
    return document.documentElement.clientWidth
  },

  getScrollbarWidth: function () {
    return window.outerWidth - document.documentElement.offsetWidth
  },

  getBodyHeight: function () {
    var body = document.body,
      html = document.documentElement

    var height = Math.max(body.scrollHeight, body.offsetHeight,
      html.clientHeight, html.scrollHeight, html.offsetHeight)

    return height
  },

  /**
 * Get all DOM element up the tree that contain a class, ID, or data attribute
 * @param  {Node} elem The base element
 * @param  {String} selector The class, id, data attribute, or tag to look for
 * @return {Array} Null if no match
 * https://gomakethings.com/climbing-up-and-down-the-dom-tree-with-vanilla-javascript/
 */
  getParents: function (elem, selector) {
    var parents = []
    var firstChar
    if (selector) {
      firstChar = selector.charAt(0)
    }

    // Get matches
    for (; elem && elem !== document; elem = elem.parentNode) {
      if (selector) {
        // If selector is a class
        if (firstChar === '.') {
          if (elem.classList.contains(selector.substr(1))) {
            parents.push(elem)
          }
        }

        // If selector is an ID
        if (firstChar === '#') {
          if (elem.id === selector.substr(1)) {
            parents.push(elem)
          }
        }

        // If selector is a data attribute
        if (firstChar === '[') {
          if (elem.hasAttribute(selector.substr(1, selector.length - 1))) {
            parents.push(elem)
          }
        }

        // If selector is a tag
        if (elem.tagName.toLowerCase() === selector) {
          parents.push(elem)
        }
      } else {
        parents.push(elem)
      }
    }

    // Return parents if any exist
    if (parents.length === 0) {
      return null
    } else {
      return parents
    }
  },
  whichTransitionEvent: function () {
    var t
    var el = document.createElement('fakeelement')
    var transitions = {
      'transition': 'transitionend',
      'OTransition': 'oTransitionEnd',
      'MozTransition': 'transitionend',
      'WebkitTransition': 'webkitTransitionEnd'
    }

    for (t in transitions) {
      if (el.style[t] !== undefined) {
        return transitions[t]
      }
    }
  },
  detectPrefixes: function () {
    let transform
    let transition
    let transitionEnd
    let hasTranslate3d;

    (function () {
      let el = document.createElement('_')
      let style = el.style

      let prop

      if (style[prop = 'webkitTransition'] === '') {
        transitionEnd = 'webkitTransitionEnd'
        transition = prop
      }

      if (style[prop = 'transition'] === '') {
        transitionEnd = 'transitionend'
        transition = prop
      }

      if (style[prop = 'webkitTransform'] === '') {
        transform = prop
      }

      if (style[prop = 'msTransform'] === '') {
        transform = prop
      }

      if (style[prop = 'transform'] === '') {
        transform = prop
      }

      document.body.insertBefore(el, null)
      style[transform] = 'translate3d(0, 0, 0)'
      hasTranslate3d = !!global.getComputedStyle(el).getPropertyValue(transform)
      document.body.removeChild(el)
    }())

    return {
      transform,
      transition,
      transitionEnd,
      hasTranslate3d
    }
  }

}

module.exports = Helpers



// WEBPACK FOOTER //
// ./assets/js/helpers.js